import React from 'react'

const WhyChooseUs = () => {
  return (
    <div>
        <div className="why-choose-us-sec ">
            <div className="container">
                <h2 className="title">Why you Should choose Signet</h2>
                <div className="row ">
                    <div className="col-md-3">
                            <div className="why-choose-col">
                                <div className="col-md-4">
                                    <img src="/img/thumbs/choose1.png" alt="choose one " />
                                </div>
                                <div className="col-md-8">
                                    <h3 className="choose-text">
                                    Learn the Latest Top Skills
                                    </h3>
                                </div>
                            </div>
                    </div>
                    <div className="col-md-3">
                         <div className="why-choose-col">
                                <div className="col-md-4">
                                    <img src="/img/thumbs/choose2.png" alt="choose two " />
                                </div>
                                <div className="col-md-8">
                                    <h3 className="choose-text">
                                    Learn the Latest Top Skills
                                    </h3>
                                </div>
                            </div>
                    </div>
                    <div className="col-md-3">
                         <div className="why-choose-col">
                                <div className="col-md-4">
                                    <img src="/img/thumbs/choose3.png" alt="choose three " />
                                </div>
                                <div className="col-md-8">
                                    <h3 className="choose-text">
                                    Learn the Latest Top Skills
                                    </h3>
                                </div>
                            </div>
                    </div>
                    <div className="col-md-3">
                         <div className="why-choose-col">
                                <div className="col-md-4">
                                    <img src="/img/thumbs/choose4.png" alt="choose four " />
                                </div>
                                <div className="col-md-8">
                                    <h3 className="choose-text">
                                    Learn the Latest Top Skills
                                    </h3>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default WhyChooseUs